module.exports = __webpack_public_path__ + "img/Picture14.8069607f.png";